function extractQueryParamFromPageURL() {
    const params = {};
    try {
        const queryString = window.location.search.substring(1);
        if (queryString === '') {
            return params;
        }
        const pairs = queryString.split('&');
        pairs.forEach(pair => {
            const [key, value] = pair.split('=');
            if (typeof key !== 'undefined' && typeof value !== 'undefined') {
                params[decodeURIComponent(key)] = decodeURIComponent(value);
            }
        });
    } catch (e) {}
    return params;
}

// 🔥 NEW: function to get cookie value
function getCookie(name) {
    try {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [key, value] = cookie.trim().split('=');
            if (key === name) {
                return decodeURIComponent(value);
            }
        }
    } catch (e) {}
    return null;
}

function setUTMParameters() {
    try {
        const queryParams = extractQueryParamFromPageURL();
        const utmKeys = [
            "utm_source",
            "utm_medium",
            "utm_campaign",
            "fbclid",
            "utm_content",
            "utm_term",
            "ref",
            "gclid",
            "shpxid"
        ];

        let newData = {};

        // Extract UTM params from URL
        Object.keys(queryParams).forEach(key => {
            if (utmKeys.includes(key)) {
                newData[key] = queryParams[key];
            }
        });

        // 🔥 Add _bm_uuid from cookies
        const bmUUID = getCookie("_bm_uuid");
        const bmHINT = getCookie("_bm_device_hint");
        if (bmUUID) {
            newData["_bm_uuid"] = bmUUID;
        }

        if(bmHINT) {
            newData["_bm_device_hint"] = bmHINT;
        }

        // Save if anything exists
        if (Object.keys(newData).length > 0) {
            localStorage.setItem("breeze_cart_attributes", JSON.stringify(newData));
        }

    } catch (e) {}
}

setUTMParameters();